import { API_URL } from '../config/api';

export const authApi = {
  register: async (email, password, firstName, lastName) => {
    const username = `${firstName} ${lastName}`;
    const response = await fetch(`${API_URL}/api/auth/local/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, username }),
    });
    if (!response.ok) throw new Error('Registratie mislukt');
    return response.json();
  },

  login: async (email, password) => {
    const response = await fetch(`${API_URL}/api/auth/local`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ identifier: email, password }),
    });
    if (!response.ok) throw new Error('Login failed');
    return response.json();
  },

  getCurrentUser: async (token) => {
    const response = await fetch(`${API_URL}/api/users/me?populate=role`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to fetch user');
    return response.json();
  },

  getUserOrders: async (email, token) => {
    const response = await fetch(
      `${API_URL}/api/orders?filters[customer_email][$eq]=${encodeURIComponent(email)}&sort=id:desc&populate=*`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (!response.ok) throw new Error('Failed to fetch orders');
    return response.json();
  },

  updateOrderStatus: async (orderId, status, token) => {
    const response = await fetch(`${API_URL}/api/orders/${orderId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ data: { status } }),
    });
    if (!response.ok) throw new Error('Failed to update order');
    return response.json();
  },
};
